Revolution.Module.extend({
    NAME: "mde.swiper-gallery", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        // _.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        $('.bk-slider-gallery').each(function (index, elem) {
            $(this).addClass('s'+index);
            var galleryThumbs = new Swiper('.s'+ index +' .gallery-thumbs', {
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,

                on: {
                    slideChangeTransitionStart: function () {
                        var imgs = this.$wrapperEl.find('.lazy:not(b-loaded)');
                        window.bLazy.load(imgs);
                    }
                },

            });

            // $('.gallery-top').each(function (index, elem) {
                var galleryTop = new Swiper('.s'+ index +' .gallery-top', {
                    spaceBetween: 10,

                    navigation: {
                        nextEl: $(elem).find('.swiper-button-next'),
                        prevEl: $(elem).find('.swiper-button-prev'),
                    },

                    loop: true,
                    fadeEffect: {
                        crossFade: true
                    },

                    speed: 1500,

                    autoplay: {
                        delay: 7000,
                    },

                    on: {
                        slideChangeTransitionStart: function () {
                            var imgs = this.$wrapperEl.find('.lazy:not(b-loaded)');
                            window.bLazy.load(imgs);
                        }
                    },

                    thumbs: {
                        swiper: galleryThumbs
                    }
                });
            // });
        });
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
    }
});
